export const getSupportedAudioSettings = (supportedConstraints) =>
  [
    supportedConstraints.channelCount && "Количество каналов",
    supportedConstraints.latency && "Latency",
    supportedConstraints.sampleRate && "Частота дискретизации",
    supportedConstraints.sampleSize && "Глубина семпла",
    supportedConstraints.noiseSuppression && "Шумоподавление",
    supportedConstraints.echoCancellation && "Эхоподавление",
    supportedConstraints.autoGainControl && "Автоматическая регулировка усиления",
  ].filter(Boolean);
